import script from "./buttonMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./buttonMenu.vue?vue&type=script&setup=true&lang=js"

import "./buttonMenu.vue?vue&type=style&index=0&id=51137ea4&lang=scss&scoped=true"

import exportComponent from "C:\\develop\\workspace_cursor\\weiquyun\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51137ea4"]])

export default __exports__